/* Draw Cloth — interactions
   Everything degrades gracefully: no JS, the page still reads and sells. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Marks the document so the reveal animation only hides content once we know
     this script ran. Without it, a blocked script means a blank page. */
  document.documentElement.classList.add('js');

  /* ---- sticky header shadow ---------------------------------------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- reveal on scroll -------------------------------------------- */
  var revealables = document.querySelectorAll('.reveal');
  if (revealables.length && 'IntersectionObserver' in window && !reduceMotion) {
    var observerReported = false;
    var io = new IntersectionObserver(function (entries) {
      observerReported = true;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    revealables.forEach(function (el, i) {
      el.style.transitionDelay = (Math.min(i % 4, 3) * 80) + 'ms';
      io.observe(el);
    });

    /* Backstop: if the observer never reported at all (tab never painted, odd
       embedding), drop the animation and show everything rather than leave the
       page blank. */
    setTimeout(function () {
      if (observerReported) return;
      io.disconnect();
      revealables.forEach(function (el) { el.classList.add('is-in'); });
    }, 2000);
  } else {
    revealables.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---- how-it-works tabs ------------------------------------------- */
  document.querySelectorAll('[data-steps]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;

    var select = function (tab) {
      tabs.forEach(function (t) {
        var selected = t === tab;
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
        t.tabIndex = selected ? 0 : -1;
        var panel = root.querySelector('#' + t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !selected;
      });
    };

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(tab); });
      tab.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1
                : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
        if (!dir) return;
        e.preventDefault();
        var next = tabs[(i + dir + tabs.length) % tabs.length];
        next.focus();
        select(next);
      });
    });
  });

  /* ---- variant picker ---------------------------------------------- */
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var scope = root.closest('form') || document;
    var idInput = scope.querySelector('[data-variant-id]');
    var priceEl = scope.querySelector('[data-price]');
    var submit = scope.querySelector('[data-submit]');

    root.addEventListener('change', function (e) {
      var input = e.target.closest('input[type="radio"]');
      if (!input) return;

      root.querySelectorAll('.variant').forEach(function (label) {
        label.classList.toggle('is-active', label.contains(input));
      });
      if (idInput) idInput.value = input.value;
      if (priceEl && input.dataset.variantPrice) priceEl.textContent = input.dataset.variantPrice;
      if (submit) {
        var available = input.dataset.variantAvailable !== 'false';
        submit.disabled = !available;
        submit.textContent = available
          ? submit.dataset.labelDefault || submit.textContent
          : (submit.dataset.labelSoldOut || 'Sold out');
      }
    });
  });

  /* ---- buy now ------------------------------------------------------- */
  /* Both buttons post the same form to /cart/add. The only difference is
     return_to: empty lands on the cart, "/checkout" goes straight to checkout.
     Set on click rather than baked into the markup, so one form serves both.
     With JS off, Buy now still adds to the cart — it just stops at the cart
     page like Add to cart does, which is a fine place to end up. */
  document.querySelectorAll('form [data-return-to]').forEach(function (field) {
    var form = field.form;
    if (!form) return;
    form.addEventListener('click', function (e) {
      var button = e.target.closest('[data-buy-now], [data-submit]');
      if (!button) return;
      field.value = button.hasAttribute('data-buy-now') ? '/checkout' : '';
    });
  });

  /* ---- product gallery ---------------------------------------------- */
  /* Every image is already in the DOM, so switching is a class toggle — no
     network round trip and no layout shift when a slide swaps in. */
  document.querySelectorAll('.pdp__media').forEach(function (root) {
    var slides = root.querySelectorAll('[data-slide]');
    var thumbs = root.querySelectorAll('[data-thumb]');
    if (!slides.length || !thumbs.length) return;

    /* A lazy image inside a hidden slide does not start downloading until the
       slide is revealed, so the first click on each thumbnail shows an empty
       box while it fetches. Once someone is browsing the gallery they want all
       of them, so drop lazy on first interaction and let them load ahead. */
    var eagerDone = false;
    function loadAll() {
      if (eagerDone) return;
      eagerDone = true;
      slides.forEach(function (slide) {
        var img = slide.querySelector('img');
        if (img && img.loading === 'lazy') img.loading = 'eager';
      });
    }

    function show(index) {
      loadAll();
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide.dataset.slide === String(index));
      });
      thumbs.forEach(function (thumb) {
        var on = thumb.dataset.thumb === String(index);
        thumb.classList.toggle('is-active', on);
        thumb.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { show(thumb.dataset.thumb); });
    });

    /* role="tab" promises arrow-key navigation, so honour it. */
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var active = root.querySelector('.pdp__thumb.is-active');
      if (!active) return;
      var i = parseInt(active.dataset.thumb, 10);
      var next = e.key === 'ArrowRight' ? i + 1 : i - 1;
      if (next < 0) next = thumbs.length - 1;
      if (next > thumbs.length - 1) next = 0;
      show(next);
      thumbs[next].focus();
      e.preventDefault();
    });
  });

  /* ---- hero video, playing itself ----------------------------------- */
  /* The default. The clip runs on its own and the page scrolls normally past
     it — nothing hijacks the wheel. It only plays while on screen, so it isn't
     burning battery underneath the rest of the page. */
  document.querySelectorAll('[data-hero-auto]').forEach(function (root) {
    var video = root.querySelector('video');
    if (!video || reduceMotion) return;

    var holdMs = parseFloat(root.dataset.heroHold || '0') * 1000;
    var speed = parseFloat(root.dataset.heroSpeed || '1');
    var onScreen = false;
    var waiting = false;

    /* muted is what buys us permission to autoplay at all */
    video.muted = true;
    video.playsInline = true;
    video.loop = !holdMs;
    if (speed > 0 && speed !== 1) video.playbackRate = speed;

    function attempt() {
      if (!onScreen || waiting) return;
      var p = video.play();
      if (p && p.catch) {
        p.catch(function () {
          /* autoplay refused — start on the first thing the visitor does */
          var kick = function () { video.play().catch(function () {}); };
          window.addEventListener('scroll', kick, { once: true, passive: true });
          window.addEventListener('pointerdown', kick, { once: true });
        });
      }
    }

    if (holdMs) {
      /* A hard cut from the final splash straight back to a clean cloth reads
         as a glitch. Let the splash sit before starting over. */
      video.addEventListener('ended', function () {
        waiting = true;
        setTimeout(function () {
          waiting = false;
          video.currentTime = 0;
          attempt();
        }, holdMs);
      });
    }

    if ('IntersectionObserver' in window) {
      var observerReported = false;
      new IntersectionObserver(function (entries) {
        observerReported = true;
        entries.forEach(function (entry) {
          onScreen = entry.isIntersecting;
          if (onScreen) attempt();
          else if (!video.paused) video.pause();
        });
      }, { threshold: 0.12 }).observe(root);

      /* If the observer never reports, the hero would sit on a frozen first
         frame forever. Assume it's visible — it is the top of the page. */
      setTimeout(function () {
        if (observerReported) return;
        onScreen = true;
        attempt();
      }, 1800);
    } else {
      onScreen = true;
      attempt();
    }

    /* fade the scroll hint out once they have actually moved */
    window.addEventListener('scroll', function () {
      root.classList.toggle('is-moved', window.scrollY > 40);
    }, { passive: true });
  });

  /* ---- scroll-scrubbed hero, drawn from frames ----------------------- */
  /* Scroll position picks a pre-rendered frame and paints it on a canvas.
     No <video>, so none of the things that make video scrubbing unreliable
     apply: no seeking, no autoplay permission, no decoder that coalesces or
     silently drops seeks, no play() promise that may never settle. The
     picture is a pure function of scroll offset, so it holds perfectly still
     until the visitor scrolls and runs backwards when they scroll up. */
  document.querySelectorAll('[data-frames]').forEach(function (root) {
    var canvas = root.querySelector('[data-frame-canvas]');
    var tag = root.querySelector('script[data-frame-urls]');
    if (!canvas || !tag || !canvas.getContext) return;

    var urls;
    try { urls = JSON.parse(tag.textContent); } catch (e) { return; }
    if (!urls || !urls.length) return;

    /* Half the frames on a small screen: the same motion for half the
       memory and half the bytes. */
    if (window.innerWidth < 900 && urls.length > 16) {
      urls = urls.filter(function (_, i) { return i % 2 === 0; });
    }

    var ctx = canvas.getContext('2d');
    var imgs = new Array(urls.length);
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var shownIndex = -1;
    var ticking = false;
    var field = (getComputedStyle(document.documentElement)
      .getPropertyValue('--field') || '#b9e0f8').trim();

    function zoom() {
      var z = parseFloat(getComputedStyle(root).getPropertyValue('--zoom'));
      return z > 0 ? z : 1;
    }

    function resize() {
      var r = canvas.getBoundingClientRect();
      if (!r.width || !r.height) return;
      canvas.width = Math.round(r.width * dpr);
      canvas.height = Math.round(r.height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      shownIndex = -1;           /* force a repaint at the new size */
      render();
    }

    /* `contain`, matching how the video was fitted: the frame's own
       backdrop is the band colour, so the letterboxing is invisible. */
    function paint(img) {
      var cw = canvas.width / dpr, ch = canvas.height / dpr;
      ctx.fillStyle = field;
      ctx.fillRect(0, 0, cw, ch);
      var s = Math.min(cw / img.naturalWidth, ch / img.naturalHeight) * zoom();
      var w = img.naturalWidth * s, h = img.naturalHeight * s;
      ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h);
    }

    function ready(i) {
      var img = imgs[i];
      return img && img.complete && img.naturalWidth > 0;
    }

    /* While the set is still downloading, show the closest frame that has
       arrived rather than a blank or a stale one. */
    function nearestReady(i) {
      for (var d = 0; d < imgs.length; d++) {
        if (ready(i - d)) return i - d;
        if (ready(i + d)) return i + d;
      }
      return -1;
    }

    function indexForScroll() {
      var runway = root.offsetHeight - window.innerHeight;
      if (runway <= 0) return 0;
      var p = -root.getBoundingClientRect().top / runway;
      p = Math.min(1, Math.max(0, p));
      return Math.round(p * (urls.length - 1));
    }

    function render() {
      ticking = false;
      var want = reduceMotion ? Math.round(urls.length * 0.55) : indexForScroll();
      var use = ready(want) ? want : nearestReady(want);
      if (use < 0 || use === shownIndex) return;
      shownIndex = use;
      paint(imgs[use]);
    }

    function request() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(render);
    }

    function load(i, onDone) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { if (onDone) onDone(); request(); };
      img.onerror = function () { if (onDone) onDone(); };
      img.src = urls[i];
      imgs[i] = img;
    }

    /* First frame first and on its own, so the hero shows something the
       moment it can, then the rest with a small concurrency cap so the
       browser doesn't spend its connections all at once. */
    load(0, function () {
      resize();
      var next = 1, live = 0, CAP = 6;
      (function pump() {
        while (live < CAP && next < urls.length) {
          live++;
          load(next++, function () { live--; pump(); });
        }
      })();
    });

    if ('ResizeObserver' in window) new ResizeObserver(resize).observe(canvas);
    else window.addEventListener('resize', resize);

    if (!reduceMotion) {
      window.addEventListener('scroll', function () {
        root.classList.toggle('is-moved', window.scrollY > 40);
        request();
      }, { passive: true });
    }

    resize();
  });

  /* ---- scrolling banner --------------------------------------------- */
  /* Two copies of the wording are rendered server-side, which is enough to
     loop but not always enough to fill a wide screen — hence the gap that
     used to swing past. Measure one group, clone until the strip is wider
     than the viewport twice over, and travel exactly one group per cycle so
     the seam never shows. Speed is derived from the distance, so longer
     wording scrolls for longer instead of scrolling faster. */
  document.querySelectorAll('[data-marquee]').forEach(function (root) {
    var track = root.querySelector('.marquee__track');
    if (!track || !track.firstElementChild) return;

    var master = track.firstElementChild;
    var PIXELS_PER_SECOND = 90;

    function fit() {
      while (track.children.length > 1) track.removeChild(track.lastElementChild);

      var groupWidth = master.getBoundingClientRect().width;
      if (!groupWidth) return;

      /* the strip is rotated and full-bleed, so measure against the viewport
         as well as the element's own box */
      var span = Math.max(root.offsetWidth, window.innerWidth);
      var copies = Math.ceil(span / groupWidth) + 2;

      var frag = document.createDocumentFragment();
      for (var i = 1; i < copies; i++) frag.appendChild(master.cloneNode(true));
      track.appendChild(frag);

      track.style.setProperty('--marquee-shift', groupWidth + 'px');
      track.style.setProperty('--marquee-dur', (groupWidth / PIXELS_PER_SECOND) + 's');
    }

    fit();

    /* webfonts land after first paint and change the measured width */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

    var t = null;
    function refit() {
      clearTimeout(t);
      t = setTimeout(fit, 180);
    }

    /* Watch the element rather than the window: this also catches the case
       where the first measurement happened before layout settled, which
       would otherwise leave the strip permanently short. */
    if ('ResizeObserver' in window) new ResizeObserver(refit).observe(root);
    window.addEventListener('resize', refit);
  });

  /* ---- the paint canvas -------------------------------------------- */
  /* The canvas is an opaque sheet of the page colour sitting over an ink
     layer. A stroke erases the sheet, so ink shows through; drying paints
     the sheet back. Two inks to choose from: full colour, and the black the
     real cloth ships with. */
  document.querySelectorAll('[data-play]').forEach(function (stage) {
    var canvas = stage.querySelector('canvas');
    if (!canvas || !canvas.getContext) return;

    var shell = stage.closest('[data-play-shell]') || stage.parentNode;
    var buttons = shell ? shell.querySelectorAll('[data-play-mode]') : [];
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var blank = (getComputedStyle(document.documentElement)
      .getPropertyValue('--ground') || '#ffffff').trim();
    var fadeMs = (parseFloat(stage.dataset.playFade) || 3) * 1000;

    var last = null;
    var painting = false;
    var wet = false;
    var lastPaintAt = 0;
    var resetTimer = null;
    /* how much of the blank sheet has been laid back down since the last
       stroke, 0 → 1 */
    var coverage = 0;

    /* Strokes are kept on their own layer rather than being carved straight
       into the visible sheet. Every frame the sheet is repainted whole and
       this layer erases it at the current strength.

       Painting the fade instead of accumulating it is what makes the dry
       even. Dabbing a little translucent paint each frame compounds — the
       first half-second eats a third of the ink and the rest crawls — and the
       increments eventually round to nothing in 8-bit, stalling short of
       blank and leaving a ghost of every stroke. Redrawing from the mask has
       no accumulated error at all: strength is simply 1 − coverage. */
    var mask = document.createElement('canvas');
    var mctx = mask.getContext('2d');

    /* one clean opaque coat — the canvas is genuinely blank afterwards */
    function fillBlank() {
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.fillStyle = blank;
      ctx.fillRect(0, 0, canvas.width / dpr, canvas.height / dpr);
    }

    /* sheet, then the wet ink punched through it at the current strength */
    function render() {
      fillBlank();
      var strength = 1 - coverage;
      if (!wet || strength <= 0.002) return;
      ctx.globalCompositeOperation = 'destination-out';
      ctx.globalAlpha = strength;
      ctx.drawImage(mask, 0, 0, canvas.width / dpr, canvas.height / dpr);
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
    }

    function reset() {
      clearTimeout(resetTimer);
      resetTimer = null;
      mctx.clearRect(0, 0, mask.width, mask.height);
      wet = false;
      coverage = 0;
      painting = false;
      last = null;
      fillBlank();
      stage.classList.remove('is-played');
    }

    /* The smooth fade rides on requestAnimationFrame, which browsers suspend
       for hidden or non-painting tabs. Returning to blank is a promise to the
       visitor, not a nicety, so a plain timer guarantees it even if no frame
       ever runs. Re-armed on every stroke. */
    function armReset() {
      clearTimeout(resetTimer);
      resetTimer = setTimeout(function () {
        if (!painting) reset();
      }, fadeMs + 400);
    }

    function resize() {
      var rect = stage.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      canvas.width = mask.width = Math.round(rect.width * dpr);
      canvas.height = mask.height = Math.round(rect.height * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      mctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      mctx.lineCap = 'round';
      mctx.lineJoin = 'round';
      reset();
    }

    function point(e) {
      var rect = canvas.getBoundingClientRect();
      return { x: e.clientX - rect.left, y: e.clientY - rect.top };
    }

    function stroke(from, to) {
      mctx.globalCompositeOperation = 'source-over';
      mctx.globalAlpha = 1;
      mctx.strokeStyle = mctx.fillStyle = '#000';
      /* a fingertip is fatter than a mouse pointer */
      mctx.lineWidth = window.innerWidth < 700 ? 34 : 46;
      mctx.beginPath();
      mctx.moveTo(from.x, from.y);
      mctx.lineTo(to.x, to.y);
      mctx.stroke();

      /* a couple of splatter dots so it feels like a wet brush */
      if (Math.random() < 0.28) {
        var r = 4 + Math.random() * 12;
        mctx.beginPath();
        mctx.arc(to.x + (Math.random() - 0.5) * 90, to.y + (Math.random() - 0.5) * 90, r, 0, Math.PI * 2);
        mctx.fill();
      }
      wet = true;
      lastPaintAt = performance.now();
      coverage = 0;
      render();
      armReset();
    }

    /* The drying pass.

       Driven by elapsed time toward a linear target, not by dabbing a fixed
       alpha every frame. A fixed alpha compounds, which front-loads the whole
       fade into the first half-second and then crawls — it reads as a snap,
       not as drying. Here coverage climbs evenly from 0 to 1 across the full
       duration, so the ink recedes at a steady, watchable rate.

       Solving for the per-frame alpha that moves accumulated coverage from
       where it is to where it should be: a = (target - current) / (1 - current).
       At the end target hits 1, a becomes 1, and the last coat is fully
       opaque — which also sidesteps the 8-bit rounding that used to stall the
       old approach just short of blank and leave a ghost of every stroke.

       Being absolute rather than incremental also makes it immune to dropped
       frames: a stall doesn't slow the dry, it just skips ahead. */
    function dry(now) {
      requestAnimationFrame(dry);
      if (!wet || painting) return;

      var target = Math.min(1, (now - lastPaintAt) / fadeMs);
      if (target <= coverage) return;
      coverage = target;
      if (coverage >= 1) { reset(); return; }
      render();
    }

    canvas.addEventListener('pointerdown', function (e) {
      painting = true;
      last = point(e);
      stage.classList.add('is-played');
      canvas.setPointerCapture(e.pointerId);
      stroke(last, { x: last.x + 0.1, y: last.y });
    });

    canvas.addEventListener('pointermove', function (e) {
      var p = point(e);
      if (painting && last) stroke(last, p);
      last = p;
    });

    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (evt) {
      canvas.addEventListener(evt, function () { painting = false; last = null; });
    });

    /* ink picker — switching wipes the sheet so the change reads cleanly */
    function setMode(mode) {
      stage.classList.toggle('play--mono', mode === 'mono');
      Array.prototype.forEach.call(buttons, function (b) {
        b.setAttribute('aria-pressed', b.dataset.playMode === mode ? 'true' : 'false');
      });
      reset();
    }
    Array.prototype.forEach.call(buttons, function (b) {
      b.addEventListener('click', function () { setMode(b.dataset.playMode); });
    });
    if (buttons.length) setMode(stage.dataset.playModeDefault || 'colour');

    var ro = 'ResizeObserver' in window ? new ResizeObserver(resize) : null;
    if (ro) ro.observe(stage); else window.addEventListener('resize', resize);

    resize();
    if (!reduceMotion) requestAnimationFrame(dry);
  });
})();
